<template>
  <!--<footer class="footer">
    <div class="footer__inner">

      <template v-if="type === 'signin'">
        <h3 class="footer__heading">Already have a <span>{{configStrings.clubName}} {{configStrings.productName}}</span>?</h3>
        <router-link class="buffer-bottom" to="/">Sign in here</router-link>
        <p>Having problems or want help with your <strong>{{configStrings.clubName}} {{configStrings.productName}}</strong>?</p>
        <a :href="configStrings.clubSSOHelpLink" >Account help</a>
      </template>

      <template v-else-if="type === 'help'">

      </template>
      <div class="footer-sponsors">


      </div>
      <div class="legalLinks">
        <a :href="configStrings.clubPrivacyPolicyLink">Privacy Policy</a>
      </div>
      <div class="legalLinks">
      This website is © {{configStrings.clubName}} {{year}}. All rights reserved
      </div>
    </div>
  </footer>-->

  <footer data-v-67f559d0="" class="footer">
    <div data-v-67f559d0="" class="footer__inner">
      
      <div data-v-940c229c="" data-v-67f559d0="" class="footer-sponsors">
        <div data-v-940c229c="" class="footer-sponsors__inner">
          <div data-v-940c229c="" class="footer-sponsors__row">
    
            <ol
              data-v-940c229c=""
              class="footer-sponsors__sponsor-wrapper footer-sponsors__sponsor-wrapper--small"
            >
              <li
                data-v-940c229c=""
                class="footer-sponsors__sponsor footer-sponsors__sponsor--small"
              >
                <a
                  data-v-940c229c=""
                  href="https://www.adidas.co.uk/football"
                  target="_blank"
                  rel="sponsored"
                  alt="Adidas"
                  class="footer-sponsors__logo"
                  aria-label="adidas.co.uk - open in a new tab"
                  data-uw-rm-empty-ctrl=""
                  data-uw-rm-ext-link=""
                  uw-rm-external-link-id="https://www.adidas.co.uk/football$adidas.co.uk"
                  style="
                    background-image: url('https://images.webapi.gc.celticfc.com/fit-in/400x400/f41b5e40-0c2d-11ee-843f-f5405c6e8a0f.png');
                  "
                ></a>
              </li>
              <li
                data-v-940c229c=""
                class="footer-sponsors__sponsor footer-sponsors__sponsor--small"
              >
                <a
                  data-v-940c229c=""
                  href="https://dafa.io/celtic-matchday"
                  target="_blank"
                  rel="sponsored"
                  alt="Dafabet"
                  class="footer-sponsors__logo"
                  aria-label="dafa.io - open in a new tab"
                  data-uw-rm-empty-ctrl=""
                  data-uw-rm-ext-link=""
                  uw-rm-external-link-id="https://dafa.io/celtic-matchday$dafa.io"
                  style="
                    background-image: url('https://images.webapi.gc.celticfc.com/fit-in/400x400/8d49cd00-49e3-11eb-9a64-eb64c969dea9.png');
                  "
                ></a>
              </li>

              <li
                data-v-940c229c=""
                class="footer-sponsors__sponsor footer-sponsors__sponsor--small"
              >
                <a
                  data-v-940c229c=""
                  href="https://www.fleetalliance.co.uk/ "
                  target="_blank"
                  rel="sponsored"
                  alt="Fleet Alliance Logo"
                  class="footer-sponsors__logo"
                  aria-label="Fleet alliance - open in a new tab"
                  data-uw-rm-empty-ctrl=""
                  data-uw-rm-ext-link=""
                  uw-rm-external-link-id="https://www.fleetalliance.co.uk/ "
                  style="
                    background-image: url('https://images.webapi.gc.celticfc.com/fit-in/400x400/e4729d90-dcb6-11ef-b01e-cd49f3bc4804.png');
                  "
                ></a>
              </li>
            </ol>
          </div>
        </div>
        <div data-v-940c229c="" class="footer-sponsors__row">
          <ol
            data-v-940c229c=""
            class="footer-sponsors__sponsor-wrapper footer-sponsors__sponsor-wrapper--small"
          >
            <li
              data-v-940c229c=""
              class="footer-sponsors__sponsor footer-sponsors__sponsor--small"
            >
              <a
                data-v-940c229c=""
                href="https://www.jdsports.co.uk/"
                target="_blank"
                rel="sponsored"
                alt="JD Sports"
                class="footer-sponsors__logo"
                aria-label="jdsports.co.uk - open in a new tab"
                data-uw-rm-empty-ctrl=""
                data-uw-rm-ext-link=""
                uw-rm-external-link-id="https://www.jdsports.co.uk/$jdsports.co.uk"
                style="
                  background-image: url('https://images.webapi.gc.celticfc.com/fit-in/400x400/ef7a36e0-49e3-11eb-9a64-eb64c969dea9.png');
                "
              ></a>
            </li>
            <li
              data-v-940c229c=""
              class="footer-sponsors__sponsor footer-sponsors__sponsor--small"
            >
            <a data-v-940c229c="" href="https://www.williamhill.com/" target="_blank" rel="sponsored" alt="William Hill Scottish Premiership" class="footer-sponsors__logo" style="background-image: url(&quot;https://images.gc.celticfc.com/fit-in/400x400/9af5b550-24d6-11ef-ad0b-996a0d187a6e.png&quot;);" data-uw-rm-brl="PR" data-uw-original-href="https://www.williamhill.com/" aria-label="williamhill.com - open in a new tab" data-uw-rm-empty-ctrl="" data-uw-rm-ext-link="" uw-rm-external-link-id="https://www.williamhill.com/$williamhill.com"></a>
            </li>
            
            <li
              data-v-940c229c=""
              class="footer-sponsors__sponsor footer-sponsors__sponsor--small"
            >
              <a
                data-v-940c229c=""
                href="https://www.skysports.com/"
                target="_blank"
                rel="sponsored"
                alt="Sky Sports"
                class="footer-sponsors__logo"
                aria-label="skysports.com - open in a new tab"
                data-uw-rm-empty-ctrl=""
                data-uw-rm-ext-link=""
                uw-rm-external-link-id="https://www.skysports.com/$skysports.com"
                style="
                  background-image: url('https://images.webapi.gc.celticfc.com/fit-in/400x400/7640c720-49e4-11eb-9a64-eb64c969dea9.png');
                "
              ></a>
              
            </li>
          </ol>
        </div>
      </div>
      


      <div class="legal">
      <div class="legalLinks"  v-for="(link, index) in configValues.footerLinks"
                        :key="index">
        <a :href="link.url">{{link.title}}</a>
      </div>
      <br />
      <div class="legalLinks">©Celtic Football Club</div>
    </div>
    </div>
    
  </footer>
</template>

<script>
export default {
  name: "FooterShout",
  data() {
    var d = new Date();
    return {
      year: d.getFullYear(),
    };
  },
  props: {
    type: {
      type: String, // register | signin | help
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/css/global.scss";

.account-help{
  
 border-bottom: 1px solid #fff;
 padding-bottom: 50px;
 margin-bottom: 10px;
 
}

.legal {
  padding: 20px;;
  margin-top: 20px;
  border-top: 1px solid #fff;
  z-index: 10;
}
.footer {
  position: relative;
  margin: 0px 0 0;
  padding: 0px 20px 10px;
  color: #fff;
  font-size: 18px;
  text-align: center;
  background-color: #010903;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    // background: transparent url('../assets/stadium-white-out@2x.png') center right no-repeat;
    background-size: cover;
    opacity: 0.4;
    z-index: 1;
  }

  &__inner {
    position: relative;
    z-index: 3;
  }

  &__heading {
    margin: 0 0 24px;
    font-size: 32px;
    font-weight: 300;

    > span {
      font-weight: 500;
    }
  }

  a {
    color: #fff;

    // &:hover {
    // text-decoration: none;
    // color: $primary-club-light;
    // }
  }

  &__telephone {
    margin: 10px 0 0;
    font-size: 34px;
    font-weight: 300;
  }
}

.buffer-bottom {
  display: inline-block;
  margin-bottom: 30px;
}

.features {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: flex-start;
  margin: 40px auto 0;
  padding: 0;
  max-width: 1200px;
  list-style: none;

  &__item {
    flex-grow: 1;
    flex-basis: 0;
    margin: 0 20px 30px;
    font-size: 15px;
    font-style: normal;
    font-weight: normal;
    line-height: 1.47;
    text-align: center;

    span {
      display: block;
    }

    &:before {
      content: "";
      display: block;
      margin: 0 auto 10px;
      height: 97px;
      width: 97px;
      background-color: rgba(255, 255, 255, 0.75);
      background-position: 50%;
      background-repeat: no-repeat;
      border: 2px solid #fff;
      border-radius: 50%;
    }

    &--store:before {
      background-image: url("../assets/features/retail.svg");
      background-size: 62px;
      background-position: 50% 45%;
    }

    &--plus:before {
      background-image: url("../assets/features/club-plus.svg");
      background-size: 62px;
      background-position: 50% 45%;
    }

    &--live:before {
      background-image: url("../assets/features/club-live.svg");
      background-size: 62px;
      background-position: 50% 45%;
    }

    &--app:before {
      background-image: url("../assets/features/app.svg");
      background-size: 62px;
    }

    &--ticketing {
      opacity: 0.5;

      &:before {
        background-image: url("../assets/features/tickets.svg");
        background-size: 62px;
      }
    }
  }
}
.legalLinks {
  margin-top: 20px;
  margin-right: 20px;
  font-size: 1rem;
  display: inline-block;

  a:link {
    color: fff;
    text-decoration: none;
  }

  /* visited link */
  a:visited {
    color: fff;
    text-decoration: none;
  }
}

.footer-sponsors {
  // background-color: footerSetting(footer_sponsors-background_color);

  &__inner {
    max-width: 1440px;
    margin: 0 auto;
    padding-top: 26px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media screen and (min-width: 760px) {
      padding-bottom: 8px;
    }
  }

  &__row {
    width: 100%;
  }

  &__row-title {
    // color: footerSetting(footer_sponsors-text_color);
    text-align: center;
  }

  &__sponsor-wrapper {
    margin: 0 auto;
    list-style-type: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    padding-left: 0;

    &--small {
      justify-content: center;

      @media screen and (min-width: 760px) {
        max-width: 720px;
      }

      @media screen and (min-width: 1024px) {
        max-width: 1032px;
      }
    }

    &--large {
      padding-bottom: 16px;
      justify-content: center;

      @media screen and (min-width: 760px) {
        padding-bottom: 12px;
      }

      @media screen and (min-width: 1024px) {
        max-width: 1032px;
        padding-bottom: 0;
      }
    }
  }

  &__sponsor {
    display: flex;
    align-items: center;

    &--small {
      width: 80px;
      height: 80px;
      margin: 0 12px 24px;

      @media screen and (min-width: 760px) {
        width: 96px;
        height: 96px;
      }

      @media screen and (min-width: 1024px) {
        margin: 0 26px 24px;
      }
    }

    &--large {
      width: 132px;
      height: 132px;
      margin: 0 12px 24px;

      @media screen and (min-width: 375px) {
        width: 160px;
        height: 160px;
      }

      @media screen and (min-width: 760px) {
        margin: 0 20px 32px;
      }

      @media screen and (min-width: 1024px) {
        margin: 0 22px 28px;
      }
    }
  }

  &__logo {
    display: block;
    height: 100%;
    width: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
}
a{
  text-decoration: none;
}
</style>